// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Plus_Jakarta_Sans_e12b3c', '__Plus_Jakarta_Sans_Fallback_e12b3c'","fontStyle":"normal"},"className":"__className_e12b3c","variable":"__variable_e12b3c"};